"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navbar = Navbar;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

require("./navbar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function DefaultRenderer(_ref) {
  var index = _ref.index,
      href = _ref.href,
      title = _ref.title,
      active = _ref.active,
      _onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "nav-link text-white px-3 text-uppercase ".concat(active ? 'active' : ''),
    href: href,
    onClick: function onClick(e) {
      return _onClick && _onClick(href);
    }
  }, title);
}

function Navbar(props) {
  var links = props.links,
      onClick = props.onClick,
      renderer = props.renderer,
      innerClassName = props.innerClassName,
      variant = props.variant,
      className = props.className,
      expand = props.expand,
      bg = props.bg,
      fixed = props.fixed,
      sticky = props.sticky,
      collapseOnSelect = props.collapseOnSelect,
      as = props.as,
      role = props.role,
      bsPrefix = props.bsPrefix;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar, _extends({
    variant: variant || "dark",
    className: className || "py-0",
    bg: bg || "primary"
  }, {
    expand: expand,
    fixed: fixed,
    sticky: sticky,
    as: as,
    role: role,
    bsPrefix: bsPrefix
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: innerClassName || "container-fluid"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, {
    className: "mr-auto"
  }, links.map(function (link, index) {
    return (renderer || DefaultRenderer)(_objectSpread(_objectSpread({}, link), {}, {
      index: index,
      onClick: onClick
    }));
  }))));
}